export default {
  components: {
    styleOverrides: {
      root: ({ ownerState, theme }: { ownerState: any; theme: any }) => ({
        ...(ownerState.position === 'start' &&
          ownerState.hasBorder && {
            height: 10,
            paddingRight: theme.spacing(2),
            borderRight: `1px solid ${theme.palette.grayBackground.A40}`
          }),
        ...(ownerState.position === 'end' &&
          ownerState.hasBorder && {
            height: 10,
            paddingLeft: theme.spacing(2),
            borderLeft: `1px solid ${theme.palette.grayBackground.A40}`
          })
      })
    }
  }
};
